import { Button } from 'src/components/Button/Button.component';
import { ButtonProps } from 'src/components/Button/Button.types';
import ModalHumanChatLoadable from 'src/components/ModalHumanChat/ModalHumanChat.loadable';
import React, { useState } from 'react';

type NeedHelpButtonProps = ButtonProps & {
  BaseComponent?: React.ComponentType<any>;
};

const NeedHelpBase = React.memo(function InputField({
  id,
  className,
  BaseComponent = Button,
  disabled,
  ...otherProps
}: NeedHelpButtonProps) {
  const [modal, setModal] = useState(false);

  return (
    <>
      <BaseComponent {...otherProps} onClick={() => setModal(true)} />
      {modal && (
        <ModalHumanChatLoadable
          i18n
          modalTitle="supportModal.Title"
          handleClose={() => setModal(false)}
        />
      )}
    </>
  );
});

export default NeedHelpBase;
